import PropTypes from 'prop-types';
import React from 'react';
import DataLabelField from './DataLabelField';

class DataLabels extends React.Component {

    render() {

        const { datasetIRI, onRemoveLabel, isReadOnly, onUpdate, canDeleteIfDefault,
            existingValues, name, labels, defaultLang, projectIRI, id } = this.props;

        if (!labels) return null;

        return (
            Object.keys(labels).sort().map((lang) => {
                const labelItems = Array.isArray(labels[lang]) ? labels[lang] : [labels[lang]];
                let positions = {};
                labelItems.forEach((label, i) => positions[label] = i);
                return <div key={lang}>
                    {
                        labelItems
                            .sort((a, b) => {
                                if (a.toLowerCase() < b.toLowerCase()) return -1;
                                if (a.toLowerCase() > b.toLowerCase()) return 1;
                                return 0;
                            })
                            .map((label, index) =>
                                <DataLabelField
                                    dataTest={name + "-" + lang + "-" + index}
                                    key={lang + "-" + label}
                                    checkValues={true}
                                    existingValues={Array.isArray(existingValues[lang]) ? existingValues[lang] : [existingValues[lang]]}
                                    datasetIRI={datasetIRI}
                                    conceptIRI={id}
                                    projectIRI={projectIRI}
                                    canDeleteIfDefault={canDeleteIfDefault || (Array.isArray(labels[defaultLang]) && labels[defaultLang].length > 1)}
                                    onUpdate={onUpdate(name, lang, Array.isArray(labels[lang]) ? positions[label] : null)}
                                    defaultLang={defaultLang}
                                    isReadOnly={isReadOnly}
                                    onDelete={() => onRemoveLabel(name, lang, label)}
                                    property={name}
                                    text={label}
                                    lang={lang} />
                            )
                    }
                </div>;
            })
        );
    }
}

DataLabels.defaultProps = {
    isReadOnly: false,
    canDeleteIfDefault: true
};

DataLabels.propTypes = {
    id: PropTypes.string.isRequired,
    labels: PropTypes.object,
    datasetIRI: PropTypes.string,
    defaultLang: PropTypes.string,
    isReadOnly: PropTypes.bool,
    projectIRI: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onRemoveLabel: PropTypes.func.isRequired,
    canDeleteIfDefault: PropTypes.bool,
    name: PropTypes.string.isRequired,
    existingValues: PropTypes.object
};

export default DataLabels;